import { ProposalCard } from './ProposalCard';

/**
 * Kanban Column Component
 * Displays proposals for a specific status
 */
export function KanbanColumn({
  status,
  statusLabel,
  proposals,
  onProposalClick,
  onVote,
  voting,
  showVoting,
  userVotes,
}) {
  return (
    <div className="t24-kanban-column">
      {/* Column Header */}
      <div className="t24-kanban-column-header">
        <h3 className="t24-kanban-column-title">{statusLabel}</h3>
        <span className="t24-kanban-column-count">{proposals.length}</span>
      </div>

      {/* Column Body */}
      <div className="t24-kanban-column-body">
        {proposals.length === 0 ? (
          <div className="t24-kanban-empty-state">
            <div className="t24-kanban-empty-icon">📋</div>
            <p className="t24-kanban-empty-text">No proposals</p>
          </div>
        ) : (
          proposals.map((proposal) => (
            <ProposalCard
              key={proposal.id}
              proposal={proposal}
              onClick={() => onProposalClick(proposal)}
              onVote={onVote}
              voting={voting}
              showVoting={showVoting && status === 'active'}
              userVote={userVotes[proposal.id]}
            />
          ))
        )}
      </div>
    </div>
  );
}
